import { useTheme } from '@/context/ThemeContext';

export default function Industries() {
  const { isDark } = useTheme();

  const industries = [
    {
      title: 'Core Trade Services',
      description: 'HVAC, plumbing, roofing, electrical, landscaping, and field service companies that require automated dispatch, lead capture, and scheduling coordination.',
      icon: 'ri-tools-line',
      image: 'https://public.readdy.ai/ai/img_res/1e18a6623bbb7d15970a429ff1b30c69.jpg',
    },
    {
      title: 'Clinical Practices',
      description: 'Medical, dental, wellness, and specialty clinics that need patient workflow automation, appointment coordination, and operational visibility.',
      icon: 'ri-heart-pulse-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20medical%20clinic%20reception%20area%20with%20digital%20check-in%20system%2C%20clean%20minimalist%20design%2C%20healthcare%20professionals%20using%20tablets%2C%20organized%20patient%20flow%2C%20teal%20accent%20lighting%2C%20professional%20medical%20environment%2C%20operational%20efficiency%20in%20healthcare%20setting&width=800&height=600&seq=clinical-practice-001&orientation=portrait',
    },
    {
      title: 'Brokerage & Capital Markets',
      description: 'Brokerages, deal advisory firms, and capital markets teams that require structured lead pipelines, automated follow-ups, and deal intelligence systems.',
      icon: 'ri-line-chart-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20financial%20brokerage%20office%20with%20multiple%20monitors%20displaying%20market%20data%20and%20analytics%20dashboards%2C%20modern%20trading%20floor%20aesthetic%2C%20structured%20data%20visualization%2C%20teal%20and%20navy%20color%20scheme%2C%20sophisticated%20capital%20markets%20technology%20environment&width=800&height=600&seq=brokerage-markets-001&orientation=portrait',
    },
  ];

  return (
    <section
      id="industries"
      className={`py-32 px-6 relative transition-colors duration-500 ${isDark ? 'bg-[#0D1B2A]' : 'bg-white'}`}
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <div className="text-[#14B8A6] text-xs font-semibold tracking-[0.3em] uppercase mb-6">WHO WE SERVE</div>
          <h2 className={`text-5xl md:text-6xl font-bold mb-6 tracking-tight transition-colors duration-500 ${isDark ? 'text-white' : 'text-[#0D1B2A]'}`}>
            Built for Operationally Complex Businesses
          </h2>
          <p className={`text-lg max-w-2xl mx-auto leading-relaxed transition-colors duration-500 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
            Specialized systems for industries that demand precision, coordination, and operational excellence.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {industries.map((industry, index) => (
            <div key={index} className="relative h-[600px] rounded-3xl overflow-hidden cursor-pointer group">
              <div className="absolute inset-0 w-full h-full">
                <img
                  src={industry.image}
                  alt={industry.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700 ease-out"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B2A] via-[#0D1B2A]/60 to-transparent" />
              <div className="absolute inset-0 p-10 flex flex-col justify-end">
                <div className="w-14 h-14 flex items-center justify-center bg-[#14B8A6]/20 backdrop-blur-xl rounded-2xl mb-6 border border-[#14B8A6]/30 group-hover:bg-[#14B8A6]/30 transition-all duration-500">
                  <i className={`${industry.icon} text-3xl text-[#14B8A6]`} />
                </div>
                <h3 className="text-3xl font-bold text-white mb-4 tracking-tight">{industry.title}</h3>
                <p className="text-gray-300 text-base leading-relaxed">{industry.description}</p>
              </div>
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none">
                <div className="absolute inset-0 bg-gradient-to-t from-[#14B8A6]/20 to-transparent" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
